import { logFetchWarning } from '~/utils/fetchErrorLog'

export default defineNuxtPlugin(async () => {
  const config = useRuntimeConfig()

  // Static preview has no SSR pass, so the server-only initializer never
  // hydrates these stores. Keep this client initializer exclusive to that build.
  if (!config.public.PREVIEW_STATIC) {
    return
  }

  const websiteInfoStore = useWebsiteInfoStore()
  const menuStore = useMenuStore()
  const themeStyleStore = useThemeStyleStore()
  const analyticStore = useAnalyticStore()
  const pdpaStore = usePDPAStore()
  const contactStore = useContactStore()
  const languageStore = useLanguageStore()
  const previewStore = usePreviewStore()
  const currencyStore = useCurrencyStore()

  try {
    await callOnce('language', () => languageStore.fetch())
    await callOnce('currency', () => currencyStore.fetch())
    await callOnce('preview', () => previewStore.fetch())
  } catch (error) {
    logFetchWarning('Failed to initialize static preview base stores', error)
  }

  await callOnce('websiteInfo', () => websiteInfoStore.fetch())

  try {
    await Promise.all([
      callOnce('menu', () => menuStore.fetch()),
      callOnce('themeStyle', () => themeStyleStore.fetch()),
      callOnce('analytic', () => analyticStore.fetch()),
      callOnce('pdpa', () => pdpaStore.fetch()),
      callOnce('contact', () => contactStore.fetch()),
    ])
  } catch (error) {
    logFetchWarning('Failed to initialize static preview page stores', error)
  }
})
